<template>
  <div class="column marquee home-marquee" ref="marqueeContainer">
    <div class="marquee-content" ref="marqueeContent">
      <div class="marquee-track" ref="marqueeTrack">
        <div class="marquee-item" v-for="n in copies" :key="n">
          <span>Forethought</span>
          <span>The White House</span>
          <span>AltSchool</span>
          <span class="dance__dance"></span>
          <span>Tamara Mellon</span>
          <span>Synack</span>
          <span>Volkswagen</span>
          <span class="dance__dance"></span>
          <span>Department of Defense</span>
          <span>Koan</span>
          <span>Modern Fertility</span>
          <span class="dance__dance"></span>
          <span>Neuralink</span>
          <span>Radpad</span>
          <span>TT.LIVE</span>
          <span class="dance__dance"></span>
          <span>Product Hunt</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { gsap } from "gsap";

const marqueeContainer = ref(null);
const marqueeContent = ref(null);
const marqueeTrack = ref(null);

const copies = ref(3); // Start with 3 copies, will adjust dynamically
let tl = null;

onMounted(() => {
  if (!marqueeTrack.value || !marqueeContainer.value) return;

  const track = marqueeTrack.value;
  const container = marqueeContainer.value;

  // Wait for next tick to ensure DOM is fully rendered
  setTimeout(() => {
    const firstItem = track.querySelector(".marquee-item");
    if (!firstItem) return;

    const itemWidth = firstItem.offsetWidth;
    const containerWidth = container.offsetWidth;

    // Validate dimensions to prevent invalid calculations
    if (itemWidth <= 0 || containerWidth <= 0) {
      console.warn(
        "Invalid dimensions for marquee calculation, using default copies"
      );
      copies.value = 3;
      setTimeout(() => {
        setupAnimation();
      }, 10);
      return;
    }

    // Calculate how many copies we need to ensure seamless coverage
    const neededCopies = Math.ceil((containerWidth * 2) / itemWidth) + 1;

    // Ensure copies is within reasonable bounds (prevent infinite or negative values)
    copies.value = Math.max(2, Math.min(neededCopies, 20));

    // Wait for Vue to re-render with new copies
    setTimeout(() => {
      setupAnimation();
    }, 10);
  }, 10);
});

const setupAnimation = () => {
  if (!marqueeTrack.value) return;

  const track = marqueeTrack.value;
  const firstItem = track.querySelector(".marquee-item");
  if (!firstItem) return;

  const itemWidth = firstItem.offsetWidth;

  // Create seamless infinite loop
  tl = gsap.timeline({ repeat: -1 });

  // Animate the entire track
  tl.fromTo(
    track,
    { x: 0 },
    {
      x: -itemWidth,
      duration: 15,
      ease: "none",
    }
  );

  // Add hover pause functionality
  const container = marqueeContainer.value;
  if (container) {
    container.addEventListener("mouseenter", () => tl.pause());
    container.addEventListener("mouseleave", () => tl.resume());
  }
};

onBeforeUnmount(() => {
  if (tl) {
    tl.kill();
  }
});
</script>

<style lang="scss" scoped>
.dance__dance {
  color: white;
}

.home-marquee {
  font-family: "Departure Mono";
  text-transform: uppercase;
  font-size: 1.5rem;
  overflow: hidden;
  white-space: nowrap;
  width: calc(100% - (4 * 51px));
  position: relative;

  .marquee-content {
    position: relative;
    height: 1.5em;
  }

  .marquee-track {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
  }

  .marquee-item {
    display: flex;
    flex-shrink: 0;

    span {
      display: inline-flex;
      padding: 0 1em;
    }
  }
}
</style>
